import { Typography } from '@sravni/react-design-system';
import type { SelectOption } from '@sravni/react-design-system/lib/Select';
import { ContentPenEdit } from '@sravni/react-icons';
import cn from 'classnames';

import { FillManuallyOptionConstants } from './FillManuallyOption.constants';
import styles from './FillManuallyOption.module.scss';
import { FillManuallyOptionTexts } from './FillManuallyOption.texts';

export const FillManuallyOption: SelectOption = {
  label: '',
  description: (
    <Typography.Text
      strong
      size={16}
      className="h-color-B100"
    >
      {FillManuallyOptionTexts.Label}
    </Typography.Text>
  ),
  value: FillManuallyOptionConstants.ManualOptionValue,
  control: <ContentPenEdit className={cn(styles.editManualIcon, 'h-color-B100')} />,
};
